import { getRuntimeConfig } from '@front/runtime-config'

import { axiosGet } from '../wrappers/axios.get.wrapper'

export const clearCookies = async (): Promise<void> => {
  const {
    public: { serviceAuthUrl },
  } = getRuntimeConfig()

  try {
    await Promise.all([
      axiosGet(`${serviceAuthUrl}/token/clear`),
      axiosGet(`${serviceAuthUrl}/token/refresh/clear`),
    ])
  } catch (error) {
    console.error(error)
  }
}
